import angular from "angular";
import "../../services/cart";

angular.module("folkeuni").component("cartMini", {
    bindings: {
        checkoutUrl: "@"
    },
    controller: function (Cart, $rootScope) {
        var $ctrl = this;
        $ctrl.ticketsSum = 0;
        $rootScope.$on("cart.update", function (evt, cart) {
            checkCartStatus(cart);
        });
        function checkCartStatus(cartObj) {
            var currentCartTicketSum = 0;
            $ctrl.cart = cartObj;
            for (const i in $ctrl.cart.products) {
                var currentProduct = $ctrl.cart.products[i];
                currentCartTicketSum = currentCartTicketSum + currentProduct.quantity;
            }

            $ctrl.ticketsSum = currentCartTicketSum;
        }
        $ctrl.$onInit = function () {
            Cart.read().then(
                function (cartObj) {
                    checkCartStatus(cartObj);
                },
                function (errorObj) {}
            );
        };
    },
    template:
        '<a ng-if="$ctrl.cart" class="mini-cart-simple link" href="{{$ctrl.checkoutUrl}}">Kurv <span class="mini-cart-simple__number hexary__bg tertiary__text" ng-if="$ctrl.ticketsSum > 0">{{$ctrl.ticketsSum > 0 ? $ctrl.ticketsSum : ""}}</span><div>'
});
